export default __webpack_public_path__ + "static/media/Truck.256.58bda67f.png";